export default __webpack_public_path__ + "static/media/36_Auburn_Map_1BR.f7bbeca6.svg";